function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128px",
    height: "128px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.885
    },
    fill: "#090a0b",
    d: "M 77.5,44.5 C 77.3747,68.4596 65.3747,79.9596 41.5,79C 37.3692,77.7645 33.3692,76.2645 29.5,74.5C 19.046,65.978 15.2127,54.978 18,41.5C 21.1667,30.3333 28.3333,23.1667 39.5,20C 59.6448,16.8903 72.3115,25.057 77.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e4e2e4",
    d: "M 40.5,23.5 C 63.1757,22.3432 74.009,33.0098 73,55.5C 65.9872,73.0897 53.4872,78.923 35.5,73C 23.0637,65.0343 18.897,53.8676 23,39.5C 26.7084,31.7472 32.5417,26.4139 40.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M 45.5,28.5 C 45.1159,30.6648 45.7826,32.3315 47.5,33.5C 49.2174,32.3315 49.8841,30.6648 49.5,28.5C 54.3999,28.0946 58.7332,29.7613 62.5,33.5C 58.4302,36.0604 54.7635,39.2271 51.5,43C 44,42.5 40.5,46 41,53.5C 39.0173,54.7657 38.0173,56.4324 38,58.5C 40.2912,59.3106 42.1246,58.4772 43.5,56C 51,56.5 54.5,53 54,45.5C 57.7729,42.2365 60.9396,38.5698 63.5,34.5C 66.3102,37.6642 68.3102,41.3308 69.5,45.5C 69.4573,46.4164 69.1239,47.0831 68.5,47.5C 66.3352,47.1159 64.6685,47.7826 63.5,49.5C 64.6685,51.2174 66.3352,51.8841 68.5,51.5C 68.0715,61.0711 63.0715,67.5711 53.5,71C 51.9343,71.765 50.6009,71.5983 49.5,70.5C 49.8841,68.3352 49.2174,66.6685 47.5,65.5C 45.7826,66.6685 45.1159,68.3352 45.5,70.5C 35.6402,70.5353 29.1402,65.5353 26,55.5C 25.235,53.9343 25.4017,52.6009 26.5,51.5C 28.6648,51.8841 30.3315,51.2174 31.5,49.5C 30.3315,47.7826 28.6648,47.1159 26.5,47.5C 26.4958,37.6152 31.4958,31.1152 41.5,28C 43.0657,27.235 44.3991,27.4017 45.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1c1c1c",
    d: "M 49.5,28.5 C 49.8841,30.6648 49.2174,32.3315 47.5,33.5C 45.7826,32.3315 45.1159,30.6648 45.5,28.5C 46.8333,27.1667 48.1667,27.1667 49.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#171617",
    d: "M 62.5,33.5 C 62.5,34.1667 62.8333,34.5 63.5,34.5C 60.9396,38.5698 57.7729,42.2365 54,45.5C 54.5,53 51,56.5 43.5,56C 42.1246,58.4772 40.2912,59.3106 38,58.5C 38.0173,56.4324 39.0173,54.7657 41,53.5C 40.5,46 44,42.5 51.5,43C 54.7635,39.2271 58.4302,36.0604 62.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.92
    },
    fill: "#040606",
    d: "M 127.5,75.5 C 127.5,78.1667 127.5,80.8333 127.5,83.5C 126.171,87.774 124.671,92.1073 123,96.5C 121.442,98.7676 119.276,99.9343 116.5,100C 112.081,107.642 105.915,109.475 98,105.5C 96.872,103.655 96.372,101.655 96.5,99.5C 82.496,99.3334 68.496,99.5001 54.5,100C 49.5009,108.073 43.0009,109.573 35,104.5C 34.5983,103.128 34.0983,101.795 33.5,100.5C 29.959,99.8 26.459,99.1334 23,98.5C 23.3423,93.1112 24.3423,87.7778 26,82.5C 26.2355,80.8807 27.0689,79.8807 28.5,79.5C 29.6946,79.8656 30.3613,80.699 30.5,82C 28.9752,86.4018 27.9752,90.9018 27.5,95.5C 30.1873,95.6641 32.854,95.4974 35.5,95C 40.4956,86.7525 46.6623,85.5858 54,91.5C 54.49,92.7932 54.6567,94.1266 54.5,95.5C 64.1896,95.8318 73.8563,95.4984 83.5,94.5C 87.6685,78.825 91.6685,63.1583 95.5,47.5C 91.1539,47.6657 86.8206,47.499 82.5,47C 81.7476,46.3292 81.4142,45.4959 81.5,44.5C 87.3188,43.3475 93.3188,43.1808 99.5,44C 100.337,45.0113 100.67,46.1779 100.5,47.5C 106.176,47.3339 111.843,47.5006 117.5,48C 118,48.5 118.5,49 119,49.5C 119.607,56.5057 120.273,63.5057 121,70.5C 123.287,72.0544 125.454,73.7211 127.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d7dc0",
    d: "M 77.5,44.5 C 78.8333,44.5 80.1667,44.5 81.5,44.5C 81.4142,45.4959 81.7476,46.3292 82.5,47C 86.8206,47.499 91.1539,47.6657 95.5,47.5C 91.6685,63.1583 87.6685,78.825 83.5,94.5C 73.8563,95.4984 64.1896,95.8318 54.5,95.5C 54.6567,94.1266 54.49,92.7932 54,91.5C 46.6623,85.5858 40.4956,86.7525 35.5,95C 32.854,95.4974 30.1873,95.6641 27.5,95.5C 27.9752,90.9018 28.9752,86.4018 30.5,82C 30.3613,80.699 29.6946,79.8656 28.5,79.5C 29.3007,77.9582 29.634,76.2915 29.5,74.5C 33.3692,76.2645 37.3692,77.7645 41.5,79C 65.3747,79.9596 77.3747,68.4596 77.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b1b1b",
    d: "M 26.5,47.5 C 28.6648,47.1159 30.3315,47.7826 31.5,49.5C 30.3315,51.2174 28.6648,51.8841 26.5,51.5C 25.1667,50.1667 25.1667,48.8333 26.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b1b1b",
    d: "M 68.5,47.5 C 69.8333,48.8333 69.8333,50.1667 68.5,51.5C 66.3352,51.8841 64.6685,51.2174 63.5,49.5C 64.6685,47.7826 66.3352,47.1159 68.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c4dbf8",
    d: "M 105.5,59.5 C 108.833,59.5 112.167,59.5 115.5,59.5C 115.5,62.8333 115.5,66.1667 115.5,69.5C 111.167,69.5 106.833,69.5 102.5,69.5C 102.583,65.8242 103.583,62.4908 105.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1c1c1c",
    d: "M 49.5,70.5 C 48.1667,71.8333 46.8333,71.8333 45.5,70.5C 45.1159,68.3352 45.7826,66.6685 47.5,65.5C 49.2174,66.6685 49.8841,68.3352 49.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.893
    },
    fill: "#000000",
    d: "M -0.5,73.5 C 7.5,73.5 15.5,73.5 23.5,73.5C 23.5,74.8333 23.5,76.1667 23.5,77.5C 15.5,77.5 7.5,77.5 -0.5,77.5C -0.5,76.1667 -0.5,74.8333 -0.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.885
    },
    fill: "#000000",
    d: "M 5.5,81.5 C 10.8333,81.5 16.1667,81.5 21.5,81.5C 21.5,82.8333 21.5,84.1667 21.5,85.5C 16.1667,85.5 10.8333,85.5 5.5,85.5C 5.5,84.1667 5.5,82.8333 5.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.059
    },
    fill: "#77a722",
    d: "M 99.5,51.5 C 104.833,51.5 110.167,51.5 115.5,51.5C 115.5,52.8333 115.5,54.1667 115.5,55.5C 104.666,52.8996 98.9997,57.0662 98.5,68C 98.3536,70.0342 99.0203,71.7009 100.5,73C 106.167,73.3333 111.833,73.6667 117.5,74C 119.792,75.2899 121.792,76.9565 123.5,79C 117.736,79.6865 117.069,81.8532 121.5,85.5C 120.958,88.6718 119.958,91.6718 118.5,94.5C 115.098,87.5512 109.764,85.7179 102.5,89C 100.649,90.6837 98.982,92.5171 97.5,94.5C 94.1667,95.8333 90.8333,95.8333 87.5,94.5C 88.7081,90.8777 89.7081,87.211 90.5,83.5C 98.7524,83.8158 106.919,83.4825 115,82.5C 115.617,81.5509 115.451,80.7175 114.5,80C 107.174,79.5003 99.8409,79.3337 92.5,79.5C 94.4299,70.0478 96.7632,60.7145 99.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.81
    },
    fill: "#000000",
    d: "M 11.5,89.5 C 14.1667,89.5 16.8333,89.5 19.5,89.5C 19.5,90.8333 19.5,92.1667 19.5,93.5C 16.8333,93.5 14.1667,93.5 11.5,93.5C 11.5,92.1667 11.5,90.8333 11.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#504853",
    d: "M 43.5,91.5 C 49.6739,90.1729 51.8406,92.5062 50,98.5C 47.7742,102.861 44.2742,104.361 39.5,103C 37.5835,98.0057 38.9168,94.1724 43.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#514853",
    d: "M 105.5,91.5 C 112.065,90.422 114.232,93.0886 112,99.5C 109.293,103.035 105.793,104.202 101.5,103C 100.409,100.936 100.242,98.7695 101,96.5C 102.707,94.9625 104.207,93.2959 105.5,91.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastDelivery);
export default __webpack_public_path__ + "static/media/fast-delivery.758addd092a57fa9ea21ec6ec5aa3ec1.svg";
export { ForwardRef as ReactComponent };